import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { TimeSheetCategoryTracking } from "../../components/TimeSheetCategoryTracking";

export const TimeSheetCategoryTrackingPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Category Tracking"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Category Tracking", navigateTo: "#" }
      ]}
      mainContents={<TimeSheetCategoryTracking />}
    />
  );
};
